import { httpResource, HttpResourceRef } from '@angular/common/http';
import { computed, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ICommonResponse } from '../../../core/models/common-response.model';
import { AppResourceStatus } from '../../../core/enums/app-resource-status';
import { IUserPermissionsRequest } from '../models/user-permissions-request.model';
import { IModuleWiseUserPermission } from '../models/module-wise-user-permission.model';
import { IFeatureWiseUserPermission } from '../models/feature-wise-user-permission.model';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  private readonly apiUrl = environment.UnifiedAPI;
  private readonly moduleWiseUserPermissionsRequest: IUserPermissionsRequest = { objecttype: 'module' };
  readonly moduleWiseUserPermissionsResource = httpResource<ICommonResponse<IModuleWiseUserPermission[]>>(() => ({
    url: this.apiUrl + '/api/v1/roles/userpermissions',
    method: 'POST',
    body: this.moduleWiseUserPermissionsRequest
  }));
  readonly moduleWiseUserPermissions = computed<IModuleWiseUserPermission[]>(() => {
    if (this.moduleWiseUserPermissionsResource.status() === AppResourceStatus.Resolved) return this.moduleWiseUserPermissionsResource.value()?.data ?? [];
    return [];
  });

  getFeatureWisePermissions(tabname: string): HttpResourceRef<ICommonResponse<IFeatureWiseUserPermission[]> | undefined> {
    const request: IUserPermissionsRequest = {
      objecttype: 'feature',
      tabname
    };
    return httpResource<ICommonResponse<IFeatureWiseUserPermission[]>>(() => ({
      url: this.apiUrl + '/api/v1/roles/userpermissions',
      method: 'POST',
      body: request
    }));
  }
}
